export const ROVO_AWARENESS_ONBOARDING_STATE_KEYS = {
	hasDismissedHomeBanner: 'rovo-awareness:hasDismissedHomeBanner',
} as const;

export const RovoAwarenessOnboardingKeys = [
	...Object.values(ROVO_AWARENESS_ONBOARDING_STATE_KEYS),
] as const;
